//@ts-ignore
let environment = __ENV__;

export enum LOG_TYPES {
	DEFAULT    = 'DEFAULT',
	USAGE      = 'USAGE',
	DIAGNOSTIC = 'DIAGNOSTIC',
	ERROR      = 'ERROR',
}

export enum SCALAR_TYPES {
	TEXT   = 'TEXT',
	NUMBER = 'NUMBER',
}

export enum CONDITION_TYPES {
	CONTAINS     = 'CONTAINS',
	NOT_CONTAINS = 'NOT_CONTAINS',
	EQUALTO      = 'EQUALTO',
	NOT_EQUALTO  = 'NOTEQUALTO',
	LESSTHAN     = 'LESSTHAN',
	GREATERTHAN  = 'GREATERTHAN',
}

export enum SESSION {
	ACTIVITY_SESSION_MIN = 30,
}

export enum POLLING {
	INTERVAL_MS = 30000
}

export const PASSWORD_REQUIREMENTS_REGEX = {
	HAS_ONE_OF_EACH:   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,64}$/,
	HAS_LOWECASE:      /^(?=.*[a-z]).{8,64}$/,
	HAS_UPPERCASE:     /^(?=.*[A-Z]).{8,64}$/,
	HAS_DIGITS:        /^(?=.*\d).{8,64}$/,
	HAS_SPECIAL_CHARS: /^(?=.*[^\da-zA-Z]).{8,64}$/,
}

export enum NETWORK_ERROR_CODES {
	AUTH_NOT_AUTHORIZED    = 'AUTH_NOT_AUTHORIZED',
	AUTH_NOT_AUTHENTICATED = 'AUTH_NOT_AUTHENTICATED',
}

export const PRODUCT_VERSION            = environment.version;
export const ENVIRONMENT_IS_PRODUCTION  = environment.isProduction;
export const ENVIRONMENT_IS_DEVELOPMENT = environment.isDevelopment;
export const ENVIRONMENT_IS_STAGING     = environment.isStaging;
export const ENVIRONMENT_IS_TESTING     = environment.isTesting;
export const ENVIRONMENT_LABEL          = environment.envTag;

export const CORVAL_SUPPORT_EMAIL = environment.contacts.supportEmail;
export const CORVAL_SUPPORT_PHONE = environment.contacts.supportPhone;
export const CORVAL_SALES_EMAIL   = environment.contacts.salesEmail;

export const CORVAL_ENTITY_NAME   = 'Corval, LLC';
export const CORVAL_PRODUCT_NAME  = 'Corval';
export const CORVAL_PLATFORM_NAME = 'Corval Software Platform';

export const DEV_LOGIN_USERNAME = environment.dev.login.username;
export const DEV_LOGIN_PASSWORD = environment.dev.login.password;

export * from './SystemRecordEnums';
